<template>
    <div v-if="id">
        <form-header title="Anmeldung" subtitle="als Ensemble zum" :tag="this.formdata.wettbewerb.name"></form-header>

        <ValidationObserver ref="form" v-if="this.formdata.wettbewerb.anmeldungOffen">
            <div>
                <div class="bg-primary">
                    <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                        <transition name="fade">
                            <div class="mt-0 mb-4 bg-red-100 border-2 border-red-200 px-4 py-4 sm:rounded-lg sm:p-4"
                                v-show="formbehaviour.alertrequired">
                                <div class="md:grid md:grid-cols-1 md:gap-3">
                                    <div class="md:col-span-1">
                                        <h3 class="leading-3">
                                            Bitte überprüfen Sie Ihre Eingabe!
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </transition>

                        <form-section title="Angaben zum Ensemble" :subtitle="'Bitte füllen Sie alle notwendigen Felder aus. <br/>Altersgruppe: ' + (this.altersgruppe() ? this.altersgruppe().name : 'n/a')">
                            <text-input v-model="wettbewerbsantritt.ensemble.name" label="Ensemblename" columns="5"
                                rules="required"></text-input>
                        </form-section>

                        <form-section title="Angaben zur Ensembleleitung"
                            subtitle="Bitte füllen Sie alle notwendigen Felder aus.">
                            <text-input v-model="wettbewerbsantritt.ensemble.leitung.titelVor" label="Titel (vorangestellt)"
                                columns="2"></text-input>
                            <div class="col-span-0 sm:col-span-4">&nbsp;</div>
                            <text-input v-model="wettbewerbsantritt.ensemble.leitung.vorname" label="Vorname" columns="3"
                                rules="required"></text-input>
                            <text-input v-model="wettbewerbsantritt.ensemble.leitung.nachname" label="Nachname" columns="3"
                                rules="required"></text-input>
                            <text-input v-model="wettbewerbsantritt.ensemble.leitung.titelNach" label="Titel (nachgestellt)"
                                columns="2"></text-input>
                            <drop-down :values="[
                                 { id: 865250000, name: 'weiblich' },
                            { id: 865250001, name: 'männlich' },
                            { id: 865250002, name: 'divers' },
                            ]" v-model="wettbewerbsantritt.ensemble.leitung.geschlecht" label="Geschlecht" rules="required"
                                columns="2">
                            </drop-down>
                            <div class="col-span-0 sm:col-span-2">&nbsp;</div>
                            <text-input v-model="wettbewerbsantritt.ensemble.leitung.email" label="E-Mail" columns="3"
                                rules="required|email"></text-input>
                            <text-input v-model="wettbewerbsantritt.ensemble.leitung.telefonnummer" label="Telefonnummer" columns="3"
                                rules="required|numeric"></text-input>
                            <drop-down :values="formdata.musikschulen" v-model="wettbewerbsantritt.ensemble.leitung.musikschuleId"
                                label="Musikschule" :rules="(wettbewerbsantritt.ensemble.leitung.anderesinstitut || wettbewerbsantritt.ensemble.leitung.privat) ? '' : 'required'" columns="5"></drop-down>
                            <text-input v-model="wettbewerbsantritt.ensemble.leitung.anderesinstitut
                                " label="Andere Institution" columns="3"></text-input>
                            <check-box label="oder Privatunterricht" columns="3"
                                v-model="wettbewerbsantritt.ensemble.leitung.privat"></check-box>
                        </form-section>

                        <!-- 1. Begleitung -->
                        <div v-if="this.id == 'vm26'" class="mb-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
                            <div class="md:grid md:grid-cols-3 md:gap-6">
                                <div class="md:col-span-1">
                                    <h3 class="text-lg font-medium leading-6 text-gray-900">Erwachsende Begleitungperson angeben?</h3>
                                    <button @click="formbehaviour.begleitung1enabled = true" type="button" class="
                                                w-20
                                                py-1
                                                text-base
                                                font-medium
                                                rounded-l-md
                                                text-white
                                                text-center
                                                hover:opacity-75
                                                mt-2
                                            "
                                        :class="[formbehaviour.begleitung1enabled ? 'bg-green-600' : 'bg-gray-400']">
                                        Ja
                                    </button>
                                    <button @click="formbehaviour.begleitung1enabled = false" type="button" class="
                                                items-center
                                                py-1
                                                w-20
                                                text-base
                                                font-medium
                                                rounded-r-md
                                                text-white
                                                text-center
                                                hover:opacity-75
                                            "
                                        :class="[!formbehaviour.begleitung1enabled ? 'bg-green-600' : 'bg-gray-400']">
                                        Nein
                                    </button>
                                </div>
                                <div class="mt-5 md:mt-0 md:col-span-2">
                                    <div class="grid grid-cols-6 gap-6 items-end" v-if="formbehaviour.begleitung1enabled">
                                        
                                        <drop-down
                                :values="formdata.instrumente"
                                label="Instrument"
                                v-model="wettbewerbsantritt.begleitung.instrumentId"
                                rules="required"
                                columns="3"
                            />

                                        <span class="col-span-3"></span>
                                        <text-input label="Vorname" v-model="wettbewerbsantritt.begleitung.vorname"
                                            rules="required" columns="2">
                                        </text-input>
                                        <text-input label="Nachname" v-model="wettbewerbsantritt.begleitung.nachname"
                                            rules="required" columns="2">
                                        </text-input>
                                        <text-input label="Geburtsdatum" v-model="wettbewerbsantritt.begleitung.geburtsdatum"
                                            rules="required|date" columns="2">
                                        </text-input>
                                        <text-input label="Straße/Nr." v-model="wettbewerbsantritt.begleitung.strasse"
                                            rules="required" columns="6">
                                        </text-input>
                                        <text-input label="PLZ" v-model="wettbewerbsantritt.begleitung.plz" rules="required"
                                            columns="3">
                                        </text-input>
                                        <text-input label="Ort" v-model="wettbewerbsantritt.begleitung.ort" rules="required"
                                            columns="3">
                                        </text-input>
                                        <drop-down :values="[
                                              { id: 865250000, name: 'weiblich' },
                            { id: 865250001, name: 'männlich' },
                            { id: 865250002, name: 'divers' },
                                        ]" v-model="wettbewerbsantritt.begleitung.geschlecht" label="Geschlecht"
                                            rules="required" columns="2">
                                        </drop-down>

                                        <text-input label="E-Mail" v-model="wettbewerbsantritt.begleitung.email"
                                            rules="required|email" columns="2">
                                        </text-input>
                                        <text-input label="Telefon" v-model="wettbewerbsantritt.begleitung.telefonnummer"
                                            rules="required" placeholder="0664 111 22 33" columns="2"></text-input>
                                        <drop-down label="Musikschule"
                                            :rules="wettbewerbsantritt.begleitung.andereInstitution ? '' : 'required'"
                                            :values="formdata.musikschulen"
                                            v-model="wettbewerbsantritt.begleitung.musikschuleId"></drop-down>
                                        <text-input label="oder andere Institution/Privat"
                                            :rules="wettbewerbsantritt.begleitung.musikschuleId ? '' : 'required'"
                                            v-model="wettbewerbsantritt.begleitung.andereInstitution"></text-input>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-for="(mitglied, index) in wettbewerbsantritt.ensemble
                            .mitglieder" :key="index" class="mt-2 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
                            <div class="md:grid md:grid-cols-3 md:gap-6">
                                <div class="md:col-span-1">
                                    <h3 class="text-lg font-medium leading-6 text-gray-900">
                                        {{ index + 1 }}. Ensemblemitglied
                                    </h3>
                                    <p class="mt-1 text-sm leading-5 text-gray-500">
                                        Bitte füllen Sie alle notwendigen Felder
                                        aus.
                                    </p>
                                    <button v-show="index > 1" @click="removeEnsembleMitglied(index)" type="button"
                                        class="mt-4 inline-flex items-center px-48 sm:px-2 py-1 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-red active:bg-red-700 transition ease-in-out duration-150">
                                        Mitglied entfernen
                                    </button>
                                </div>
                                <div class="mt-5 md:mt-0 md:col-span-2">
                                    <div class="grid grid-cols-6 gap-6">
                                        <drop-down
                                :values="formdata.instrumente"
                                label="Instrument"
                                v-model="mitglied.instrumentId"
                                rules="required"
                                columns="6"
                            />
                                        <text-input v-model="mitglied.vorname" label="Vorname" columns="3"
                                            rules="required"></text-input>
                                        <text-input v-model="mitglied.nachname" label="Nachname" columns="3"
                                            rules="required"></text-input>
                                        <text-input v-model="mitglied.geburtsdatum" label="Geburtsdatum" columns="2"
                                            rules="required|date"></text-input>
                                        <drop-down :values="[
                                              { id: 865250000, name: 'weiblich' },
                            { id: 865250001, name: 'männlich' },
                            { id: 865250002, name: 'divers' },
                                        ]" v-model="mitglied.geschlecht" label="Geschlecht" rules="required" columns="2">
                                        </drop-down>
                                        <text-input v-model="mitglied.strasse" label="Straße/Nr." columns="5"
                                            rules="required"></text-input>
                                        <text-input v-model="mitglied.plz" label="PLZ" columns="2"
                                            rules="required"></text-input>
                                        <text-input v-model="mitglied.ort" label="Ort" columns="4"
                                            rules="required"></text-input>
                                        <text-input v-model="mitglied.email" label="E-Mail" columns="3"
                                            rules="required|email"></text-input>
                                        <text-input v-model="mitglied.telefonnummer" label="Telefonnummer" columns="3"
                                            rules="required|numeric"></text-input>
                                        <drop-down label="Musikschule"
                                            :rules="mitglied.andereInstitution ? '' : 'required'"
                                            :values="formdata.musikschulen"
                                            v-model="mitglied.musikschuleId"></drop-down>
                                        <text-input label="oder andere Institution/Privat"
                                            :rules="mitglied.musikschuleId ? '' : 'required'"
                                            v-model="mitglied.andereInstitution"></text-input>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mb-6 mt-2 bg-white shadow px-4 py-4 sm:rounded-lg sm:p-4">
                            <div class="md:grid md:grid-cols-3 md:gap-6">
                                <div class="md:col-span-1">&nbsp;</div>
                                <div class="grid grid-cols-6 gap-6">
                                    <div class="col-span-6">
                                        <span class="inline-flex rounded-md shadow-sm">
                                            <button @click="addEnsembleMitglied" type="button"
                                                class="inline-flex items-center px-48 sm:px-4 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-green active:bg-green-700 transition ease-in-out duration-150">
                                                weiteres Mitglied hinzufügen
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mb-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6 border-2"
                        :class="[musikstueckeValid() == '' ? 'border-green-300' : 'border-red-300']"
                        v-if="altersgruppe()">
                        In der Altersgruppe <strong>{{ altersgruppe().name }}</strong> sind {{ altersgruppe().pflichtstuecke }}
                        Musikstücke notwendig.<br /><strong>{{ musikstueckeValid()
}}</strong>
                    </div>

                        <div v-for="(stueck, index) in wettbewerbsantritt.musikstuecke" :key="index"
                            class="mt-2 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
                            <div class="md:grid md:grid-cols-3 md:gap-6">
                                <div class="md:col-span-1">
                                    <h3 class="text-lg font-medium leading-6 text-gray-900">
                                        {{ index + 1 }}. Stück
                                    </h3>
                                    <p class="mt-1 text-sm leading-5 text-gray-500">
                                        Bitte füllen Sie alle notwendigen Felder
                                        aus.
                                    </p>
                                    <button v-show="index != 0" @click="removeEnsembleStueck(index)" type="button"
                                        class="mt-4 inline-flex items-center px-48 sm:px-2 py-1 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-red active:bg-red-700 transition ease-in-out duration-150">
                                        Stück entfernen
                                    </button>
                                </div>
                                <div class="mt-5 md:mt-0 md:col-span-2">
                                    <div class="grid grid-cols-6 gap-6">
                                        <text-input v-model="stueck.titel" label="Titel" columns="4"
                                            rules="required"></text-input>
                                        <text-input v-model="stueck.dauer" label="Dauer" columns="2"
                                            rules="required"></text-input>
                                        <text-input v-model="stueck.komponist" label="Komponist" columns="3"></text-input>
                                        <drop-down :values="[
                                             { name: 'Alpenländische Volksmusik', id: 865250005 },
                                        { name: 'Volksmusik aus den östlichen Bundesländern Österreichs', id: 865250004 },
                                        { name: 'Europäische Volksmusik', id: 865250006 },
                                        { name: 'Zeitgenössische Volksmusik', id: 865250007 },
                                        ]" v-model="stueck.kategorie" label="Kategorie" rules="required"
                                            columns="3"></drop-down>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mb-6 mt-2 bg-white shadow px-4 py-4 sm:rounded-lg sm:p-4">
                            <div class="md:grid md:grid-cols-3 md:gap-6">
                                <div class="md:col-span-1">&nbsp;</div>
                                <div class="grid grid-cols-6 gap-6">
                                    <div class="col-span-6">
                                        <span class="inline-flex rounded-md shadow-sm">
                                            <button @click="addEnsembleStueck" type="button"
                                                class="inline-flex items-center px-48 sm:px-4 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-green active:bg-green-700 transition ease-in-out duration-150">
                                                weiteres Stück hinzufügen
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <form-section title="Informationspflicht" subtitle="gem. Art. 13 DSGVO">
                            <div class="col-span-6 sm:col-span-5">
                                <text-block :content="textbausteinfuer(
                                    'allgemein.informationspflicht'
                                ).contentPlain
                                    " />
                            </div>
                        </form-section>

                        <form-section title="Bild und Ton">
                            <div class="col-span-6 sm:col-span-5">
                                <text-block :content="textbausteinfuer(
                                    'zustimmung.bildundton'
                                ).contentPlain
                                    " />
                            </div>
                        </form-section>

                        <div class="mt-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
                            <div class="md:grid md:grid-cols-3 md:gap-6">
                                <div class="md:col-span-1">&nbsp;</div>
                                <div class="grid grid-cols-6 gap-6">
                                    <div class="col-span-6">
                                        <span class="inline-flex rounded-md shadow-sm">
                                            <button @click="sendAnsuchen()" type="button"
                                                class="inline-flex items-center px-48 sm:px-8 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-green active:bg-green-700 transition ease-in-out duration-150">
                                                Formular absenden
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ValidationObserver>
        <div v-else>
            <form-section>
                <div class="col-span-6 sm:col-span-5">
                    Die Anmeldung zu diesem Wettbewerb ist derzeit nicht möglich
                </div>
            </form-section>
        </div>

        <transition name="fade">
            <div
                class="fixed inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-end">
                <div v-show="formbehaviour.sending"
                    class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto">
                    <div class="rounded-lg shadow-xs overflow-hidden">
                        <div class="p-4">
                            <div class="flex items-start">
                                <div class="flex-shrink-0">
                                    <svg class="h-6 w-6 text-green-400" fill="none" viewBox="0 0 24 24"
                                        stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div>
                                <div class="ml-3 w-0 flex-1 pt-0.5">
                                    <p class="text-sm leading-5 font-medium text-gray-900">
                                        Validierung erfolgreich.
                                    </p>
                                    <p class="mt-1 text-sm leading-5 text-gray-500">
                                        Übermittle das Formular.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div v-show="formbehaviour.successful"
                class="fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center">
                <div v-show="formbehaviour.successful" class="fixed inset-0 transition-opacity">
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <div v-show="formbehaviour.successful"
                    class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-sm sm:w-full sm:p-6">
                    <div>
                        <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                            <svg class="h-6 w-6 text-green-600" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                            </svg>
                        </div>
                        <div class="mt-3 text-center sm:mt-5">
                            <h3 class="text-lg leading-6 font-medium text-gray-900">
                                Erfolgreich gesendet.
                            </h3>
                            <div class="mt-2">
                                <p class="text-sm leading-5 text-gray-500">
                                    Vielen Dank für Ihre Anmeldung.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import FormSection from '@/components/forms/FormSection.vue'
import FormHeader from '@/components/forms/FormHeader.vue'

import TextInput from '@/components/inputs/TextInput.vue'

import TextAreaInput from '@/components/inputs/TextAreaInput.vue'
import CheckBox from '@/components/inputs/CheckBox.vue'
import DropDown from '@/components/inputs/DropDown.vue'
import RadioButtonList from '@/components/inputs/RadioButtonList.vue'
import TextBlock from '@/components/inputs/TextBlock.vue'

import FileUpload from '@/components/inputs/FileUpload.vue'

export default {
    name: 'Form',
    inject: ['service'],
    props: {
        id: {
            id: String,
            required: true,
        },
    },
    components: {
        TextInput,
        TextAreaInput,
        CheckBox,
        DropDown,
        FormSection,
        FormHeader,
        RadioButtonList,
        TextBlock,
        FileUpload,
    },
    data: function () {
        return {
            formbehaviour: {
                begleitungAvailable: false,
                begleitung1enabled: false,
                showSendModal: false,
                alertrequired: false,
                sending: false,
                successful: false,
            },
            formdata: {
                wettbewerb: {},
                musikschulen: [],
                textbausteine: [],
                instrumente: [],
                altersgruppen: [],
            },
            wettbewerbsantritt: {
                altersgruppeId: null,
                wettbewerbId: null,
                kontaktEmail: null,
                ensemble: {
                    name: null,
                    leitung: {
                        vorname: null,
                        nachname: null,
                        titelVor: null,
                        titelNach: null,
                        geburtsdatum: null,
                        strasse: null,
                        plz: null,
                        ort: null,
                        email: null,
                        telefonnummer: null,
                        musikschuleId: null,
                        andereInstitution: null,
                        instrumentId: null,
                        geschlecht: null,
                    },
                    mitglieder: [
                        {
                            vorname: null,
                            nachname: null,
                            geburtsdatum: null,
                            email: null,
                            telefonnummer: null,
                            strasse: null,
                            plz: null,
                            ort: null,
                            musikschuleId: null,
                            andereInstitution: null,
                            instrumentId: null,
                            geschlecht: null,
                        },
                        {
                            vorname: null,
                            nachname: null,
                            geburtsdatum: null,
                            email: null,
                            telefonnummer: null,
                            strasse: null,
                            plz: null,
                            ort: null,
                            musikschuleId: null,
                            andereInstitution: null,
                            instrumentId: null,
                            geschlecht: null,
                        },
                    ]
                },
                musikstuecke: [
                    {
                        reihenfolge: 1,
                        titel: null,
                        komponist: null,
                        dauer: null,
                        kategorie: null,
                    },
                ],
                begleitung: {
                    vorname: null,
                    nachname: null,
                    geburtsdatum: null,
                    geschlecht: null,
                    strasse: null,
                    ort: null,
                    plz: null,
                    telefonnummer: null,
                    email: null,
                    instrumentId: null,
                    musikschuleId: null,
                    andereInstitution: null,
                },
            },
        }
    },
    watch: {
    },
    computed: {
       
    },
    methods: {
        async fetchWettbewerb() {
           const { data } = await this.service.wettbewerb.get(this.id).info()
           this.formdata.wettbewerb = data
        },
        async fetchAltersgruppen() {
           const { data } = await this.service.wettbewerb.get(this.id).altersgruppen(2);
           this.formdata.altersgruppen = data
        },
        addEnsembleMitglied: function () {
            this.wettbewerbsantritt.ensemble.mitglieder.push({
                vorname: null,
                nachname: null,
                geburtsdatum: null,
                email: null,
                geschlecht: null,
            })
        },

        addEnsembleStueck: function () {
            this.wettbewerbsantritt.musikstuecke.push({
                titel: null,
                komponist: null,
                dauer: null,
                kategorie: null,
            })
        },

        removeEnsembleMitglied: function (index) {
            this.wettbewerbsantritt.ensemble.mitglieder.splice(index, 1)
        },

        removeEnsembleStueck: function (index) {
            this.wettbewerbsantritt.musikstuecke.splice(index, 1)
        },

        addToEnsembleLeiterInstrumente(e) {
            if (
                !this.wettbewerbsantritt.ensemble.leitung.instrumente.find(
                    inst => inst.id == e
                )
            )
                this.wettbewerbsantritt.ensemble.leitung.instrumente.push({
                    id: e,
                    name: this.formdata.instrumente.find(inst => inst.id == e)
                        .name,
                })
        },

        async fetchTextBausteine() {
            const { data } = await this.service.formular
                .get('volksmusik')
                .textbloeckePowerApps()
            this.formdata.textbausteine = data
        },

        async fetchMusikschulen() {
            const { data } = await this.service.musikschule.powerAppsAlle()
           
            this.formdata.musikschulen = data
            this.formdata.musikschulen.sort((a, b) =>
                a.kurzbezeichnung > b.kurzbezeichnung ? 1 : -1
            )
        },
        async fetchInstrumente() {
            const { data } = await this.service.wettbewerb.get(this.id).faecher();
            this.formdata.instrumente = data
        },
        altersgruppe() {      
             
            var gruppe = this.getAltersgruppe();

            return gruppe;
        },
        getAge(dateString) {
            if (!dateString)
                return null;

            var pattern = /(\d{1,2})\.(\d{1,2})\.(\d{4})/;
            var birthDate = new Date(dateString.replace(pattern, '$3-$2-$1'));

            var today = new Date(this.formdata.wettbewerb.stichtag);
            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age;
        },
        getAltersgruppe() {
            var ageOfGroup = 0;
            var maxAge = 0;
            for(let i = 0; i < this.wettbewerbsantritt.ensemble.mitglieder.length; i++){
                var ageOfMember = this.getAge(this.wettbewerbsantritt.ensemble.mitglieder[i].geburtsdatum)

                if(ageOfMember){
                    ageOfGroup += ageOfMember;
                    maxAge = maxAge > ageOfMember ? maxAge : ageOfMember;
                }
            }

            ageOfGroup = ageOfGroup / this.wettbewerbsantritt.ensemble.mitglieder.length;
            
            var altersgruppe = this.formdata.altersgruppen.find(ag => ag.alterVon <= ageOfGroup && maxAge <= ag.maximalalter);

            if(altersgruppe){
                return altersgruppe;
            }

            return {
                name: '---',
                id: null
            }
        },
        async sendAnsuchen() {
            var validation = await this.$refs.form.validate();

            if (!validation || this.musikstueckeValid() != '') {
                window.scrollTo(0, 0)
                this.formbehaviour.alertrequired = true
                return
            }

            try {
                if (!this.formbehaviour.begleitung1enabled)
                    this.wettbewerbsantritt.begleitung = null;

                this.formbehaviour.showSendModal = true
                this.formbehaviour.sending = true

                this.wettbewerbsantritt.wettbewerbId = this.formdata.wettbewerb.id;
                this.wettbewerbsantritt.altersgruppeId =  this.altersgruppe().id;
                this.wettbewerbsantritt.kontaktEmail = this.wettbewerbsantritt.ensemble.leitung.email;

                await this.service.wettbewerb.senden(this.wettbewerbsantritt)
                this.formbehaviour.showSendModal = false
                this.formbehaviour.successful = true

            } catch (error) {
                console.log(Object.keys(error), error.message)
                this.formbehaviour.successful = false
            } finally {
                this.formbehaviour.sending = false
                this.formbehaviour.showSendModal = false
            }
        },
        musikstueckeValid() {
            var altersgruppe = this.altersgruppe();

            if (altersgruppe == null)
                return 'Keine Altersgruppe gefunden.';

            if (altersgruppe.pflichtstuecke > this.wettbewerbsantritt.musikstuecke.length)
                return 'Momentan sind zu wenige Musikstücke angegeben.';

            var gesamtdauer = 0;
            var pflichtkategorie = false;
            var kategorien = [];

            this.wettbewerbsantritt.musikstuecke.forEach(stueck => {
                if (stueck.dauer != null && stueck.dauer.indexOf(':') > -1)
                    stueck.dauerInMinuten = ((Number(stueck.dauer.split(':')[0]) * 60) + Number(stueck.dauer.split(':')[1])) / 60.0;
                else
                    stueck.dauerInMinuten = 0;
                gesamtdauer += stueck.dauerInMinuten;

                pflichtkategorie = pflichtkategorie || stueck.kategorie == 865250005;
                if(!kategorien.includes(stueck.kategorie) && stueck.kategorie){
                    kategorien.push(stueck.kategorie);
                }
            });

            if (altersgruppe.spielzeitMin > gesamtdauer)
                return 'Die Gesamtdauer der Musikstücke ist zu kurz.';

            if (altersgruppe.spielzeitMax < gesamtdauer)
                return 'Die Gesamtdauer der Musikstücke ist zu lang.';

            if (!pflichtkategorie || kategorien.length < 2)
                return 'Mind. zwei verschiedene Kategorien sind abzudecken, mind. ein Stück aus der Kategorie "Alpenländische Volksmusik"';

            return '';

        },

        textbausteinfuer(id) {
            const found = this.formdata.textbausteine.find(
                element => element.identifier == id
            )

            if (!found) return id

            return found
        },

        async initData() {
            await this.fetchWettbewerb()
            await this.fetchAltersgruppen()
            await this.fetchMusikschulen()
            await this.fetchTextBausteine()
            await this.fetchInstrumente()

        },
    },
    created() {
        this.initData()
    },

    beforeDestroy() { },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
